
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-insights/[slug]",
      function () {
        return require("private-next-pages/real-estate-insights/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-insights/[slug]"])
      });
    }
  